import { AxiosError, AxiosRequestConfig } from 'axios'
import { getCurrentAuthState } from '~/atoms/AuthenticationState'
import { useUserState } from '~/atoms/UserState'

import { ApisauceInstance } from '@mangovoice/apisauce'

const logRateLimitedRequest = (config: AxiosRequestConfig | undefined) => {
  const authState = getCurrentAuthState()
  const { sessionUser } = useUserState()
  const userId =
    sessionUser?.id ??
    authState.session?.user.id ??
    authState.validationToken?.user ??
    'unknown'
  const extensions = { ...authState.validationToken?.data }

  //for now just log the error and some info about the error
  window.gtag('event', 'rate_limit_error', {
    route: config?.url ?? 'unknown_url',
    userId,
    extensions,
  })
}

const rateLimitResponseInterceptor = (error: AxiosError) => {
  const responseCode = error.response?.status ?? 0
  if (responseCode === 429) {
    logRateLimitedRequest(error.config)
  }

  return Promise.reject(error)
}

export const setRateLimitInterceptors = (
  apiSauceInstances: ApisauceInstance[],
) => {
  apiSauceInstances.forEach((apiSauceInstance) => {
    apiSauceInstance.axiosInstance.interceptors.response.use(
      undefined,
      rateLimitResponseInterceptor,
    )
  })
}
